import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";

export const setDate = ({date, store, productId, categoryId}) => (dispatch) => {

    dispatch({type: 'SET_DATE', payload: date});

    let object = {};
    if (productId) {
        object = {
            'date': formatDate(date),
            'store_id': store.id,
            'product_id': productId
        };
    }

    if (categoryId) {
        object = {
            'date': formatDate(date),
            'store_id': store.id,
            'category_id': categoryId
        };
    }

    fetch('/api/free-times?' + new URLSearchParams(object))
        .then((response) => {
            if (!response.ok) {
                alert('Ups.. etwas ist schiefgelaufen, bitte versuchen Sie es später erneut.');
                throw new Error('Bad response from server');
            }
            return response.json();
        })
        .then((data) => {
            let freeTimes = [];
            for (const key in data.times) {
                if (data.times[key].is_free) {
                    freeTimes.push(setHours(setMinutes(new Date(), 0), data.times[key].hour));
                }
            }
            dispatch({
                'type': 'SET_FREE_TIMES',
                'payload': {
                    freeTimes: freeTimes,
                    times: data.times,
                    members: data.members
                }
            })
        })

}


function formatDate(date) {
    var month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}
